import { useTranslation } from "react-i18next";
import { type DocumentSource } from "@/hooks/use-document-repo";

// One-line source chips, one hue per source: Document (blue), Form evidence
// (purple), Task (amber), Notice (green), CROMERR (teal), Report form (pink).
// whitespace-nowrap keeps each chip a single line in the dense table.
const SOURCE_CLASSES: Record<DocumentSource, string> = {
  document: "bg-blue-50 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300",
  form: "bg-purple-50 text-purple-700 dark:bg-purple-900/30 dark:text-purple-300",
  task: "bg-amber-50 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300",
  notice: "bg-green-50 text-green-700 dark:bg-green-900/30 dark:text-green-300",
  cromerr: "bg-teal-50 text-teal-700 dark:bg-teal-900/30 dark:text-teal-300",
  report_form_output: "bg-pink-50 text-pink-700 dark:bg-pink-900/30 dark:text-pink-300",
};

interface DocumentSourceBadgeProps {
  source: DocumentSource;
}

/** A one-line source-vocabulary chip for a repository document row. */
export function DocumentSourceBadge({ source }: DocumentSourceBadgeProps) {
  const { t } = useTranslation("documents");
  return (
    <span
      className={`inline-flex whitespace-nowrap rounded px-2 py-0.5 text-[11px] font-semibold ${SOURCE_CLASSES[source]}`}
    >
      {t(`repo.source.${source}`)}
    </span>
  );
}
